<template>
  <div class="share">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/joinYG/header.png" alt="" />
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="" />
        <span>首页 > 加入雅格</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="content-main">
      <div class="flex">
        <div class="left">
          <img src="../assets/joinYG/img.png" alt="" />
        </div>
        <div class="middle">
          <div>
            <img src="../assets/joinYG/joinyg.png" alt="" />
          </div>
          <div>
            <img src="../assets/joinYG/more.png" alt="" />
          </div>
        </div>
        <div class="right">
          <div class="up">
            <p>应聘方式 Application method</p>
            <div class="img">
              <div>
                <img src="../assets/joinYG/email.png" alt="" />
              </div>
              <div>
                <img src="../assets/joinYG/fax.png" alt="" />
              </div>
            </div>
            <!-- 分隔符 -->
            <div class="CuttingLine">
              .....................................................................................................................................................................................................................................................................
            </div>
          </div>

          <div class="down">
            <p>电话：0571-8608626</p>
            <p>地址：杭州市西溪路浙大科技园A座3层</p>
          </div>
        </div>
      </div>
      <!-- 招聘 -->
      <div class="job-main">
        <div class="job" v-for="(item, index) in information" :key="index">
          <div
            :class="item.rotomate ? 'job-tips' : 'job-tips jobtips-rotomate'"
            @click="rotomateClick(index)"
          >
            <div>{{ item.position }}</div>
            <div>{{ item.type }}</div>
            <div>工作地址：{{ item.address }}</div>
            <div>发布时间：{{ item.time }}</div>
            <div :class="item.rotomate ? 'arrow' : 'icon-rotate arrow'">
              <img src="../assets/joinYG/down.png" alt="" />
            </div>
          </div>
          <div
            :class="
              item.rotomate && item.description.length > 0
                ? 'job-detail'
                : 'hidden'
            "
          >
            <div>
              <p class="title">职务描述</p>
              <p class="tips" v-for="(items, i) in item.description" :key="i">
                {{ items }}
              </p>
            </div>
            <div>
              <p class="title" style="margin-top: 50px">岗位要求</p>
              <p class="tips" v-for="(items, i) in item.require" :key="i">
                {{ items }}
              </p>
            </div>
            <div style="margin-top: 10px">
              <span style="color: red">*</span>
              <span style="color: #818181"> 有意者请发简历至邮箱 </span>
              <a style="color: red">yagehz@163.com</a>
              <span style="color: #818181">，邮件名格式：</span>
              <span>姓名+性别+岗位+可入职时间</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      information: [
        {
          // 是否翻转
          rotomate: true,
          // 职务
          position: "java工程师",
          // 职位类别
          type: "产品研发类",
          // 工作地
          address: "杭州",
          // 发布时间
          time: "2022-2-1",
          // 职务描述
          description: [
            "1. 能够理解客户需求，完成基本设计。",
            "2. 完成核心业务模块的代码编写。",
            "3. 协调内部开发与供应商开发之间方案的讨论和选定。",
          ],
          // 岗位要求
          require: [
            "1. 有5年以上Java开发经验。",
            "2. 有团队合作意识和良好的沟通，了解软件工程基本知识",
            "3. 工作有责任感，抗压能力强。",
            "4. 有金融行业尤其是银行业软件开发经验",
          ],
        },
        {
          rotomate: false,
          // 职务
          position: "C++开发工程师",
          // 职位类别
          type: "产品研发类",
          // 工作地
          address: "杭州",
          // 发布时间
          time: "2022-2-1",
          // 职务描述
          description: [
            "1.根据公司统一的技术方向及规范和开发管理要求进行软件开发，包括编写代码和单元测试，审查代码，修复Bug以及编写所需文档。",
            "2.编写相关的开发及产品文档，相关产品的售后技术支持",
            "3.从事基于windows的应用软件开发，其他上级分配的技术相关工作",
            "4.及时向项目经理汇报开发过程中遇到的问题以及需要的开发资源，以确保项目顺利进行。",
            "5.查找定位与解决客户软件使用过程中遇到的问题，参与公司期货或证券业务功能模块的开发。",
            "6.完成上级交办的其他各项工作。",
          ],
          // 岗位要求
          require: [
            "1、本科以上学历，有C/C++开发工作经验，熟悉金融终端底层开发经验者优先",
            "2、熟练使用C/C++语言，有较好的数据结构理论知识",
            "3、掌握Linux/Unix/Windows下多线程/多进程编程及socket编程；",
            "4、熟悉mysql,oracle数据库技术，可使用C/C++相关API进行数据库的操作；",
            "5、熟练掌握linux下gcc，gdb，makefile等开发环境使用；",
            "6、熟练掌握Windows下VC++开发环境使用；",
            "7、良好的学习能力、沟通能力及团队协作精神，能够承受一定工作压力；",
            "8、工作积极主动、踏实认真，有较强的表达能力和写作能力，善于主动沟通和主动学习，具有团队精神，吃苦耐劳，愿意付出。",
          ],
        },
        {
          rotomate: false,
          // 职务
          position: "前端工程师",
          // 职位类别
          type: "产品研发类",
          // 工作地
          address: "杭州",
          // 发布时间
          time: "2022-2-1",
          // 职务描述
          description: [
            "1.参与产品前端框架设计、技术选型等",
            "2.负责产品前端开发，前端技术研究等；",
            "3.负责配合交付类项目的需求调研、定制化开发、问题处理、系统升级及维护",
          ],
          // 岗位要求
          require: [
            "1.2年以上的web前端开发经验，了解前后端分离的开发模式；",
            "2.至少熟悉Vue、Angular、React等中任一种前端框架，熟练掌握前端开发技术；",
            "3.熟练使用HTML5、CSS3、HTML、XHTML、CSS等网页和软件撰写技术，熟悉页面架构和布局；",
            "4.熟悉http协议和前后端交互技术，如ajax、websocket等；",
            "5.有一定的审美能力；",
            "6.熟悉制造业信息化相关业务优先考虑；",
            "7.有Three.js和webgl开发经验优先考虑",
          ],
        },
        // {
        //   rotomate: false,
        //   // 职务
        //   position: "采购工程师",
        //  // 职位类别
        //   type: "支撑类",
        //   // 工作地
        //   address: "杭州",
        //   // 发布时间
        //   time: "2022-2-1",
        //   // 职务描述
        //   description: [
        //     '1、公司所需生产设备及原材料及时的供应以及采购成本有效的控制',
        //     '2、调查研究公司各部门物资需求及消耗情况，熟悉各种物资的供应渠道和市场变化情况，指导并监督员工开展业务；',
        //     '3、统筹策划和确定采购内容，监督和参与采购业务洽谈，合同模板和价格洽谈，审核商品采购合同、协议；',
        //     '4、收集供应商信息，组织对供应商的评估工作，按计划完成公司各类物资的采购任务，并在预算内尽可能降低采购成本',
        //   ],
        //   // 岗位要求
        //   require: [
        //     '1、大专及以上学历，工科类、管理类、物流类专业，2年以上的采购经验工作经验；',
        //     '2、有钣金、机加工、电气、电子等专业知识；',
        //     '3、了解采购相关的法律，熟悉合同法、招投标法等相关知识；',
        //     '4、有一定的财务基础知识，能看懂财务报表，有一定的质量管理基础和风控意识；',
        //     '5、较强的分析能力、应变能力和决策能力，对价格敏感，有较强的议价能力，有较强的风控意识；',
        //     '6、诚实正直，性格开朗，品行优良，责任心强，工作细致积极主动，具有良好的职业操守，有较强的服务意识。',
        //   ],
        // },
        // {
        //   rotomate: false,
        //   // 职务
        //  position: "出纳",
        //  // 职位类别
        //   type: "支撑类",
        //   // 工作地
        //   address: "杭州",
        //   // 发布时间
        //   time: "2022-2-1",
        //   // 职务描述
        //   description: [
        //     "1、日常到访客人的接待、登记工作，协助领导做好相关公司协调工作",
        //     '2、整理资料，收费，开票，现金管理，采购等工作。',
        //     '3、协助会计准备日、月单据及报表等；',
        //     '4、办理与银行之间的所有相关业务；',
        //     '5、完成公司交办的其他事务性工作。',
        //   ],
        //   // 岗位要求
        //   require: [
        //     '1、应届大专、本科生，财务类、人力资源管理等相关专业均可；',
        //     '2、对数据敏感，有会计上岗证优先；',
        //     '3、工作认真仔细、踏实肯干，有服从意识；',
        //   ],
        // },
        // {
        //   rotomate: false,
        //   // 职务
        //  position: "会计",
        //  // 职位类别
        //   type: "支撑类",
        //   // 工作地
        //   address: "杭州",
        //   // 发布时间
        //   time: "2022-2-1",
        //   // 职务描述
        //   description: [
        //     '1、负责公司日常账务核算、审核原始凭证；',
        //     '2、负责税收核算，申报和管理工作；',
        //     '3、完成部门领导交办的其他工作。',
          
        //   ],
        //   // 岗位要求
        //   require: [
        //     '1、本科及以上学历，财会等相关专业，中级会计师职称以上优先；',
        //     '2、3年以上会计岗位工作经验；',
        //     '3、熟悉行业财税政策及会计准则，熟练使用用友NC财务软件，熟练EXCEL等办公软件的操 作；',
        //     '4、诚实守信、正直、责任心强，沟通能力强，具有优秀的团队合作精神',
        //   ],
        // },
        // {
        //   rotomate: false,
        //   // 职务
        //  position: "大数据平台架构师",
        //  // 职位类别
        //   type: "产品研发类",
        //   // 工作地
        //   address: "杭州",
        //   // 发布时间
        //   time: "2022-2-1",
        //   // 职务描述
        //   description: [
        //     '1. 负责基于Hadoop/Spark等生态系统的大数据平台的架构设计、技术选型、搭建、开发、管理、监控和性能调优，负责数据存储、查询引擎、实时计算、元数据管理的架构设计；',
        //     '2. 对大数据相关的前沿技术进行预研，负责大数据平台技术框架的选型和技术难点攻关；',
        //     '3. 制定和开发相关技术规范，提升团队标准化工作水平；',
        //     '4. 牵引团队积极开展对外合作和交流，快速提升团队在业界的影响力',
        //   ],
        //   // 岗位要求
        //   require: [
        //     '1. 计算机相关专业硕士及以上学历， 3年以上大数据架构开发经验；',
        //     '2. 在大数据领域有系统化的研究和成功的项目经验，对Hadoop及周边生态主流技术有深入的理解，具备大数据技术栈丰富的架构与实战经验；',
        //     '3. 熟悉分布式计算系统的工作机制，具有分布式文件系统、分布式数据库系统、集群存储系统等架构设计经验；',
        //     '4. 具备社交大数据、用户行为大数据等相关业务领域经验者优先；',
        //     '5. 具有良好的沟通、组织和团队协作能力，优秀的分析问题和解决问题的能力，对解决具有挑战性问题充满激情。',
        //   ],
        // },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    // 跳转页面
    skipUrl(url) {
      console.log(url);
      // this.$router.push(url);
    },
    // 控制是否翻转
    rotomateClick(i) {
      this.information.forEach((item) => {
        if (!this.information[i].rotomate) {
          item.rotomate = false;
        }
      });
      this.information[i].rotomate = !this.information[i].rotomate;
      console.log(this.information[i].rotomate);
    },
  },
};
</script>
<style scoped lang="scss">
.share {
  width: 100%;
  font-family: Source Han Sans CN;
  font-weight: bold;
  margin: 0;
  padding: 0;
  // 头部
  .section {
    margin: 0 0 -5px;
    position: relative;
    color: #ffffff;
    img {
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips {
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div {
      margin-left: 12%;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
      span {
        font-size: 10px;
        color: #808080;
        margin: 0 6px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  // 整体内容
  .content-main {
    width: 100%;
    background: #f5f5fa;
    padding: 40px 0;
    box-sizing: border-box;
    // 图片展示
    .flex {
      margin: 0 auto 20px;
      display: flex;
      justify-content: space-between;
      max-width: 1200px;
      .left {
        width: 38%;
        img {
          width: 100%;
          // height: 300px;
        }
      }
      .middle {
        width: 20%;
        img {
          width: 100%;
          // height: 147px;
        }
      }
      .right {
        width: 38%;
        background-image: url("../assets/joinYG/bg.png");
        // background: #0090E2;
        overflow: hidden;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
        .up {
          // height: 50%;
          // margin-top: 40px;
          p {
            font-size: 20px;
            margin: 15px auto 5px;
          }
          .img {
            display: flex;
            width: 60%;
            justify-content: space-around;
            margin: 0 20%;
            align-items: center;
            img {
              width: 60px;
              height: 60px;
            }
          }
        }
        // 分隔符
        .CuttingLine {
          width: 100%;
          font-family: Source Han Sans CN;
          font-weight: 400;
          height: 20%;
        }
        .down{
          margin-top: 8%;
        }
      }
    }
    // 招聘
    .job-main {
      max-width: 1200px;
      background: #f5f5fa;
      margin: 0 auto;
      .job {
        width: 1200px;
        margin: 20px 0;
        cursor: pointer;
        // 工作表头第一列
        .job-tips {
          width: 100%;
          height: 50px;
          line-height: 50px;
          color: #ffffff;
          font-size: 16px;
          display: flex;
          justify-content: space-between;
          padding: 0 20px;
          box-sizing: border-box;
          background: #015fb2;
          div {
            width: 300px;
          }
          // 箭头
          .arrow {
            width: 30px;
            height: 30px;
            background: #ffffff;
            margin: 10px 0;
            border-radius: 50%;
            position: relative;
            transition: all 0.5s ease-out;
            img {
              position: absolute;
              top: 12px;
              left: 8px;
            }
          }
          // 是否翻转
          .rotateimg {
            transition: all 0.5s ease-out;
          }
          .icon-rotate {
            transform: rotate(-90deg);
            background: #d4d1d1;
          }
        }
        // 工作表头
        .jobtips-rotomate {
          background: #ffffff;
          color: #b1b1b1;
        }
        // 职务详细信息
        .job-detail {
          background: #f5f5fa;
          padding: 20px 0;
          box-sizing: border-box;
          // display: block;
          opacity: 1;
          transition: all 0.5s ease;
          .title {
            color: #138cdf;
            line-height: 20px;
            font-size: 16px;
            margin: 0;
          }
          .tips {
            display: inline-block;
            font-size: 14px;
            margin: 0;
            padding: 0;
            height: 25px;
            line-height: 25px;
            color: #abafaf;
          }
        }
        // 职务详细信息不显示
        .hidden {
          display: none;
          opacity: 0;
          height: 0;
          transition: all 0.5s ease;
        }
      }
    }
  }
}
</style>
